export const ControlTypes = {
  big_string: 'big_string',
  text: 'text',
  small_string: 'small_string',
  integer: 'integer',
  double: 'double',
  boolean: 'boolean',
  options: 'options',
  dropdown: 'dropdown',
  radioButtons: 'radioButtons',
  slider: 'slider',
  slot_selection: 'slot_selection',
  media_selection: 'media_selection',
  color_picker: 'color_picker',
  font_picker: 'font_picker',
  custom_control: 'custom_control',
  link_picker: 'link_picker',
  image_selection: 'image_selection',
  thumbnails: 'thumbnails',
  input: 'input',
  button: 'button',
  drag_list: 'drag_list',
} as const;

export type ControlTypeKey = keyof typeof ControlTypes;
